import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const StatBox = ({ count, label, icon, color, onClick }) => {
  return (
    <FlexBox flexDirection="column" alignItems="center">
      <Paper
        elevation={0}
        onClick={onClick}
        sx={{
          textAlign: "center",
          p: 2.5,
          borderRadius: "50%",
          aspectRatio: "1 / 1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: color,
          color: "white",
          cursor: "pointer",
          transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0 8px 20px -5px" + color,
          },
        }}
      >
        <Typography variant="h3" component="div" fontWeight="bold">
          {count}
        </Typography>
      </Paper>
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
        {/* {icon} */}
        <Typography
          variant="body2"
          fontWeight="medium"
          align="center"
          sx={{ fontSize: "clamp(17px, 2.5vw, 20px);" }}
        >
          {label}
        </Typography>
      </Box>
    </FlexBox>
  );
};
